import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { EntidadConvenioDTO, EnvioCorreoElectronicoInterfaz } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class EntidadConvenioService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getEntidadConvenioPorEntidadService(codigo:string): Observable<BodyListResponse<EntidadConvenioDTO>> {
    return this.http.get<BodyListResponse<EntidadConvenioDTO>>(API_URL + '/api/v1/entidadConvenio/entidad/'+codigo);
  }

  getEntidadConvenioService(): Observable<BodyListResponse<EntidadConvenioDTO>> {
    return this.http.get<BodyListResponse<EntidadConvenioDTO>>(API_URL + '/api/v1/entidadConvenio/todos');
  }

  guardarEntidadConvenioService(entidadConvenioDTO: EntidadConvenioDTO): Observable<BodyResponse<EntidadConvenioDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/entidadConvenio', entidadConvenioDTO);
  }

  getEntidadConvenioPorCodigoEntidadConvenioService(codigoEntidadConvenio: string): Observable<BodyResponse<EntidadConvenioDTO>> {
    return this.http.get<BodyResponse<EntidadConvenioDTO>>(API_URL + '/api/v1/entidadConvenio/' + codigoEntidadConvenio);
  }
  /*********nuevos */
  notificarCorreoEntidadConvenioService(entidadConvenioDTO: EnvioCorreoElectronicoInterfaz): Observable<BodyResponse<any>> {
    return this.http.post<any>(API_URL + '/api/v1/entidadConvenio/envioMensaje', entidadConvenioDTO);
  }
}
